export const getQueryParams = (path: string) => {
    const searchStart = path.indexOf('?');

    if (searchStart === -1) {
        return {};
    }

    const queryString = path.slice(searchStart + 1);

    if (!queryString) {
        return {};
    }

    const params = new URLSearchParams(queryString);
    const result: Record<string, string> = {};

    params.forEach((value, key) => {
        result[key] = value;
    });

    return result;
};
